import { service } from '../../service';
import { icons } from '../../service/icons';
import { iconsDemo } from '../../service/icons';
import i18n from '../../i18n';

const state = {
  themes: [],
  currentTheme: {},
  idChannel: process.env.ID_CHANNEL || 1,
  homeData: [{ 'id': 'home','category': 'home', 'logoSvg': icons.home }, {
    'id': 'trends_recent_all',
    'title': i18n.t('categories.trends_recent_all'),
    'category': 'trends_recent_all',
    'logo': null,
    'children': []
  }, { 'id': 'popular', 'title': i18n.t('categories.popular'), 'category': 'popular', 'logo': null, 'children': [] }, {
    'id': 'all',
    'title': i18n.t('categories.all')
    , 'category': 'all',
    'logo': null,
    'children': []
  }]

};

const mutations = {
  FETCH_THEMES(state, themes) {
    state.themes = themes;
  },
  SET_CURRENT_THEME(state, currentTheme) {
    state.currentTheme = currentTheme;
  }
};

const getters = {
  getAllThemes(state) {
    return state.themes;
  },
  getHomeData(state) {
    return state.homeData;
  }
};

const actions = {
  async fetchThemes({ commit },mode) {
    const { data } = process.env.ID_CHANNEL ? (await service.getThemesWithChildrenByData({idChannel : process.env.ID_CHANNEL}) ):(await service.getThemesWithChildren()) ;
    const themes = data.themes;

    let icon= icons.home
    if(mode=='demo')
      icon = iconsDemo.home
    if ( process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.CUSTOM_ICON)
      icon = icons.customhome;
    const home = {
      id: 0,
      logoSvg: icon
    };
    themes.unshift(home);
    commit('FETCH_THEMES', themes);
  },
  async setCurrentTheme({ commit }, id) {
    const { data } = await service.getThemeDetailById(id);
    commit('SET_CURRENT_THEME', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/themes.js